import React, {useEffect, useState} from 'react';
import { getLeadOrders } from '../../utilities/marketUtil';
import { useSelector, useDispatch } from 'react-redux';
import { unixTommddyyyy } from '../../utilities/dashFunction';
import { formatStates } from '../../utilities/genericUtils';
import Dropdown from '../../utilities/helperComponents/Dropdown';
import Icon from '../../assets/icons/icon';


function PastOrders({ }) {    
    const agentInfo=useSelector((state) => state.agent.userData);
    const [pastOrders, setPastOrders] = useState(false);
    const loadingGif=useSelector((state) => state.loading.loading);
        const [tableOptions, setTableOptions] = useState({
            start: 0,
            end: 10,
            size: 10,
            row: 10,
            maxRow: 100
        })

    useEffect(() => {
        getLeadOrders(setPastOrders,agentInfo.agentId)
    },[])

    const pageOptions = [
        {
            label: '10',
            value: 10
        },
        {
            label: '15',
            value: 15
        },
        {
            label: '20',
            value: 20
        },
    ]

    const updateTableSize = (size) => {
        const updatedOptions = { ...tableOptions, size }

        updatedOptions.start = 0
        updatedOptions.end = updatedOptions.size

        setTableOptions(updatedOptions)
    }

    const getNextRow = () => {
        if (tableOptions.end >= pastOrders.length) return;

        const updatedOptions = { ...tableOptions };
        updatedOptions.start = tableOptions.end;
        updatedOptions.end = Math.min(tableOptions.end + tableOptions.size, pastOrders.length);

        setTableOptions(updatedOptions);
    };

    const getPrevRow = () => {
        if (tableOptions.start === 0) return;

        const updatedOptions = { ...tableOptions };
        updatedOptions.start = Math.max(tableOptions.start - tableOptions.size, 0);
        updatedOptions.end = tableOptions.start;

        setTableOptions(updatedOptions);
    };


    return (
        <div className={`quilityParentBlockWrapper twoX selectable`}>
            <div className="quilityParentBlockHeader">
                <div className="quilityParentBlockTitle">Previous Orders</div>
            </div>
            <div>
            <button className='refresh_orderbtn' onClick={() => getLeadOrders(setPastOrders, agentInfo.agentId)} >
                 <Icon name='refresh-q' height={18} size={18}  color='#fff' className="refresh_svg"   />
                Refresh Orders</button>
            </div>
            <div className="quilityParentBlockContent">
                {pastOrders && pastOrders.length > 0 ? (
                    <>
                    <div className={`quilityNestedBlockWrapper `} style={{marginTop: '25px'}}>
                        {pastOrders.slice(tableOptions.start, tableOptions.end).map((item, index) =>(
                            <div className="quilityNestedBlockContent">
                        <div className="quilityDataLine">
                        {item.order_id && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Id</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.order_id}</span>
                        </div> }
                         <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Vendor</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.vendorName}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Type</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.typeName}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Date</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{unixTommddyyyy(item.order_date)}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Quantity</span>
                        <span className="quilityDataLineValue" style={{ padding: '0.25rem 0'}}>{item.order_size}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Fulfilled</span>
                        <span className="quilityDataLineValue " style={{ padding: '0.25rem 0' }}>{item.fulfilled}</span>  
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Value</span>
                        <span className="quilityDataLineValue " style={{ padding: '0.25rem 0'}}>$ {(item.total_amount / 100)}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding:'0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Type</span>
                        <span className="quilityDataLineValue" style={{padding:'0.25rem 0'}}>{(item.order_type === 'standing' || item.order_type === 'SLO') ? 'SLO' : 'OTLO'}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>States</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{formatStates(item.states)}</span>
                        </div>   
                       {item.lead_level && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Level</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.lead_level}</span>
                        </div>} 
                       {(item.lead_order_status || item.status) && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Order Status</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.lead_order_status ? item.lead_order_status : item.status }</span>
                        </div> }                 
                    </div>
                </div> 
                        ))}
                    </div>

                    <div style={{ width: '100%', background: 'white', justifyContent: 'flex-end', alignItems: 'center', gap: 36, display: 'inline-flex' }}>
                            <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'flex' }}>
                                <div style={{ color: 'black', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.06, wordWrap: 'break-word' }}>Rows per page:</div>
                                <div style={{ overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 4, display: 'flex' }} className='light_dropbox'>
                                    <Dropdown
                                        disabled={loadingGif}
                                        options={pageOptions}
                                        changeHandler={e => updateTableSize(parseInt(e.target.value))}
                                        inputValue={tableOptions.size}
                                    />
                                </div>
                            </div>
                            <div style={{ fontSize: 13 }}>
                                {pastOrders.length > 0
                                    ? `${tableOptions.start + 1} – ${Math.min(tableOptions.end, pastOrders.length)} of ${pastOrders.length}`
                                    : '0 – 0 of 0'}
                            </div>
                            
                            <div style={{ justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex' }}>
                                <div onClick={e => loadingGif ? null : getPrevRow()} style={{ padding: 10, 
                                     borderRadius: 100, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer', background: tableOptions.start === 0 ? '#E4E4E4' : '#46C3B2', }}>
                                    <div style={{ width: 18, height: 18, position: 'relative' }}>
                                        <div style={{ width: 6, height: 10, position: 'absolute', }} >
                                            <Icon name='q-chevron-left' height={18} size={18} adjust="fontello" color='#D0D0D0' viewBox="0 0 16 16" strokeOptions={{ stroke: "white", width: "2", lineCap: "round", lineJoin: "round" }} />
                                        </div>
                                    </div>
                                </div>
                                <div onClick={e => loadingGif ? null : getNextRow()} style={{ padding: 10, background: tableOptions.end >= pastOrders.length ? '#E4E4E4' : '#46C3B2', borderRadius: 100, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer' }}>
                                    <div style={{ width: 18, height: 18, position: 'relative' }}>
                                        <div style={{ width: 6, height: 10, position: 'absolute' }}>
                                            <Icon name='q-chevron-right' height={18} size={18} adjust="fontello" color='#D0D0D0' viewBox="0 0 16 16" strokeOptions={{ stroke: "white", width: "2", lineCap: "round", lineJoin: "round" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    </>
                ) : (
                    <div className="title">You have no previous orders</div>
                ) }   
            </div>
            <div className="clearFooter">
                
            </div>
        </div>
    );
}

export default PastOrders;

/*<div className="quilityDataLine" key={`leadPreview${index}`}>
                            <span className="quilityDataLineTitle extraIndent" style={{display: 'inline-block',width: '200px'}}></span>
                        </div>*/
